import React from 'react';
import { midas, colors } from '@resurs/midas';
const RadioButton = ({ children, id, label, text, name, checked = false, disabled = false, onChange, dataCy, }) => (React.createElement("div", { className: midas.formGroup, "data-cy": dataCy },
    label && (React.createElement("label", { className: midas.formLabel, htmlFor: id }, label)),
    React.createElement("label", { className: midas.formRadio },
        React.createElement("input", { id: id, type: "radio", name: name, checked: checked, disabled: disabled, onChange: onChange }),
        React.createElement("i", { className: midas.formIcon }),
        ' ',
        React.createElement("div", { style: {
                ...(disabled ? { color: colors.gray2 } : {}),
                ...{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                },
            } }, text)),
    children));
export default RadioButton;
